import React from 'react';

const CommunityGuidelines: React.FC = () => (
  <div className="max-w-3xl mx-auto py-16 px-4">
    <h1 className="text-5xl font-extrabold mb-6 bg-gradient-to-r from-blue-600 via-purple-500 to-pink-500 bg-clip-text text-transparent drop-shadow-lg flex items-center gap-3">
      <span>🤝</span> Community Guidelines
    </h1>
    <div className="bg-white/80 rounded-2xl shadow-xl p-6 mb-8">
      <p className="text-xl font-semibold mb-4 text-gray-800">My English Gurukul is a <span className="bg-gradient-to-r from-pink-400 to-blue-400 bg-clip-text text-transparent font-bold">safe, positive space</span> for everyone to learn and grow. We’re committed to building a supportive community where all learners feel welcome.</p>
    </div>
    <div className="border-l-4 border-blue-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2"><span>💬</span> Be Respectful</h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>Encourage and support fellow learners.</li>
        <li>Use kind, inclusive language at all times.</li>
        <li>Respect different backgrounds, cultures, and learning styles.</li>
      </ul>
    </div>
    <div className="border-l-4 border-pink-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-pink-700 flex items-center gap-2"><span>🛡️</span> Keep It Safe</h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>No bullying, harassment, or hate speech.</li>
        <li>No spamming or advertising.</li>
        <li>Protect your privacy and the privacy of others.</li>
      </ul>
    </div>
    <div className="border-l-4 border-yellow-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-yellow-700 flex items-center gap-2"><span>📢</span> Reporting Issues</h2>
      <p className="mb-2 text-gray-700 text-lg">If you see any inappropriate behavior or content, please report it to us at <a href="mailto:community@englishguru.com" className="text-blue-600 underline font-bold">community@englishguru.com</a>. We take all reports seriously and will act quickly to keep our community safe.</p>
    </div>
    <div className="mt-10 text-center">
      <span className="inline-block text-xl font-semibold text-blue-600 bg-blue-100 rounded-full px-6 py-2 shadow">Let’s make My English Gurukul a place where everyone can thrive! 🌈</span>
    </div>
  </div>
);

export default CommunityGuidelines; 